import { render, staticRenderFns } from "./RectangleBgCard.vue?vue&type=template&id=2a13c346&"
import script from "./RectangleBgCard.vue?vue&type=script&lang=js&"
export * from "./RectangleBgCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports